module.exports = __webpack_public_path__ + "img/logistic-postat.faaba6a.png";